import { LayerDefinition } from './types';

export const cpcOutlookDefinition: LayerDefinition = {
  id: 'cpc_outlook',
  name: 'CPC Extended Outlooks',
  category: 'extended_climate',
  categoryLabel: 'Extended Climate & Outlooks',
  icon: '📈',
  description: 'Authoritative NOAA Climate Prediction Center (CPC) probabilistic outlooks for temperature and precipitation anomalies covering 6-10 Day, 8-14 Day (Week 2), and Monthly planning horizons.',
  sourceModels: [
    'NOAA Climate Prediction Center (CPC)',
    'Global Ensemble Forecast System (GEFS)',
    'ECMWF Integrated Forecasting System Ensemble (EPS)',
    'Canadian Meteorological Centre Ensemble (CMCE)'
  ],
  outputModels: ['CPC Anomaly Probability Contours GeoJSON'],
  config: {
    cadence: 'Daily (6-10d / 8-14d) & Monthly'
  }
};

export default cpcOutlookDefinition;
